// declare module '@yaireo/tagify';
// declare module '@yaireo/tagify/dist/react.tagify';
import { callSP } from './setup/axios/AxiosCallSP'
import { StringSchema, ArraySchema } from 'yup'
import moment from 'moment'
declare module 'yup' {
  class StringSchema {
    firstCapitalLetter(): this
  }
  class ArraySchema {
    validateArray(): this
  }
}

const fetchData = async (name: string, parameters: any, state: any) => {
  const response: any = await callSP(name, parameters)

  if (state !== null) {
    if (response.status === 200) state(response.data.result)
  }
}

const fotmatDateHeader = (date: string) => {
  let localLocale = moment(date)
  localLocale.locale(false)
  moment.locale('es')
  return translateDay(localLocale.format('ddd DD-MM-YYYY'))
}

const fotmatDateHeader2 = (date: string) => {
  let localLocale = moment(date)
  localLocale.locale(false)
  moment.locale('es')
  return translateDay(localLocale.format('YYYY-MM-DD'))
}

const translateDay = (day: string) => {
  if (day.toLowerCase().includes('mon')) return day.replace('Mon', 'Lu')
  if (day.toLowerCase().includes('tue')) return day.replace('Tue', 'Ma')
  if (day.toLowerCase().includes('wed')) return day.replace('Wed', 'Mi')
  if (day.toLowerCase().includes('thu')) return day.replace('Thu', 'Ju')
  if (day.toLowerCase().includes('fri')) return day.replace('Fri', 'Vi')
  if (day.toLowerCase().includes('sat')) return day.replace('Sat', 'Sá')
  if (day.toLowerCase().includes('sun')) return day.replace('Sun', 'Do')
  return day
}

export const groupBy = (xs: Array<any>, key: any) => {
  return xs.reduce(function (rv, x) {
    ; (rv[x[key]] = rv[x[key]] || []).push(x)
    return rv
  }, {})
}

export const groupByMultiple = (array: any, f: any) => {
  const groups = {}
  array.forEach((o: any) => {
    var group = JSON.stringify(f(o))
    groups[group] = groups[group] || []
    groups[group].push(o)
  })
  return Object.keys(groups).map(function (group) {
    return groups[group]
  })
}

// Función auxiliar para limpiar localStorage de datos antiguos relacionados con minutas
const cleanupMinutaStorage = (excludeKey?: string) => {
  const keysToClean = [
    'dataRowB', 
    'dataContratoGrilla', 
    'idContratoGrilla',
    'idMinutaGrilla',
    'idMinutaGrillaLong',
    'versionMinuta',
    'version',
    'openFechas',
    'parametersChangeSelected',
    'ingredienteSeleccionado',
    'ingredienteSeleccionado2',
    'dataTP'
  ]
  
  keysToClean.forEach(key => {
    if (key !== excludeKey) {
      try {
        localStorage.removeItem(key)
      } catch (e) {
        // Ignorar errores al limpiar
      }
    }
  })
}

// Función para optimizar/comprimir datos antes de guardar
const optimizeDataForStorage = (data: any): any => {
  if (!data) return data
  
  // Si es un array, optimizar cada elemento
  if (Array.isArray(data)) {
    return data.map(item => optimizeDataForStorage(item))
  }
  
  // Si es un objeto, eliminar propiedades innecesarias o null/undefined
  if (typeof data === 'object') {
    const optimized: any = {}
    for (const key in data) {
      const value = data[key]
      // Mantener solo valores que no sean null, undefined o strings vacíos (a menos que sean importantes)
      if (value !== null && value !== undefined && value !== '') {
        optimized[key] = optimizeDataForStorage(value)
      }
    }
    return optimized
  }
  
  return data
}

export const setLStorage = (parameter: string, data: any) => {
  try {
    // Optimizar datos antes de guardar para reducir el tamaño
    const optimizedData = optimizeDataForStorage(data)
    const jsonString = JSON.stringify(optimizedData)
    
    localStorage.setItem(parameter, jsonString)
  } catch (error: any) {
    // Manejar error de cuota excedida
    if (error.name === 'QuotaExceededError' || error.code === 22) {
      console.warn(`Quota excedida al guardar '${parameter}'. Intentando estrategias de limpieza...`)
      
      // Estrategia 1: Si es dataRowMinuta, reducir el stack gradualmente
      if (parameter === 'dataRowMinuta' && Array.isArray(data)) {
        // Intentar con diferentes tamaños de stack hasta que funcione
        const stackSizes = [30, 20, 15, 10, 5, 3, 1]
        
        for (const size of stackSizes) {
          try {
            const limitedData = data.slice(0, size)
            const optimized = optimizeDataForStorage(limitedData)
            localStorage.setItem(parameter, JSON.stringify(optimized))
            console.warn(`Stack de undo limitado a ${limitedData.length} elementos para evitar exceder la cuota.`)
            return
          } catch (retryError) {
            // Continuar con el siguiente tamaño
            continue
          }
        }
        
        // Si todos los tamaños fallan, intentar limpiar otros datos primero
        try {
          cleanupMinutaStorage(parameter)
          if (data.length > 0) {
            const optimized = optimizeDataForStorage([data[0]])
            localStorage.setItem(parameter, JSON.stringify(optimized))
            console.warn(`Solo se guardó el estado más reciente después de limpiar otros datos.`)
            return
          }
        } catch (finalError) {
          console.error(`No se pudo guardar '${parameter}' incluso después de limpiar datos.`, finalError)
          throw finalError
        }
      }
      
      // Estrategia 2: Si es ingredienteSeleccionado, eliminar campos grandes (dataRowB, dataColumn)
      if (parameter === 'ingredienteSeleccionado' || parameter === 'ingredienteSeleccionado2') {
        try {
          // Crear una copia sin los campos grandes que causan problemas
          const optimizedJson: any = {}
          const fieldsToKeep = [
            'idIngrediente', 'idColumn', 'id_receta', 'fecha', 'numRow', 
            'id_alergeno', 'id_estilo_aliminatacion', 'id_intolerancia', 
            'id_sellos', 'id_categoria_dietetica', 'id_grupo_estructura', 'idGrid'
          ]
          
          for (const key of fieldsToKeep) {
            if (data[key] !== undefined && data[key] !== null) {
              optimizedJson[key] = data[key]
            }
          }
          
          // Intentar guardar la versión optimizada
          localStorage.setItem(parameter, JSON.stringify(optimizedJson))
          console.warn(`'${parameter}' guardado sin campos grandes (dataRowB, dataColumn) para evitar cuota excedida.`)
          return
        } catch (optimizedError) {
          // Si aún falla, continuar con la limpieza general
          console.warn(`No se pudo guardar '${parameter}' incluso sin campos grandes, intentando limpieza...`)
        }
      }
      
      // Estrategia 3: Para otros casos, limpiar datos relacionados y reintentar
      try {
        cleanupMinutaStorage(parameter)
        
        // Optimizar datos antes de guardar nuevamente
        const optimizedData = optimizeDataForStorage(data)
        localStorage.setItem(parameter, JSON.stringify(optimizedData))
        console.warn(`Datos guardados después de limpiar claves relacionadas.`)
      } catch (retryError) {
        // Último intento: limpiar todo excepto la clave actual y datos críticos
        try {
          // Limpiar todas las claves excepto la actual y algunas críticas
          const criticalKeys = [parameter, 'accessToken', 'refreshToken']
          for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i)
            if (key && !criticalKeys.includes(key)) {
              try {
                localStorage.removeItem(key)
              } catch (e) {
                // Ignorar errores
              }
            }
          }
          
          const optimizedData = optimizeDataForStorage(data)
          localStorage.setItem(parameter, JSON.stringify(optimizedData))
          console.warn(`Datos guardados después de limpieza agresiva de localStorage.`)
        } catch (finalRetryError) {
          console.error(`Error crítico: No se pudo guardar '${parameter}' en localStorage después de todos los intentos.`, finalRetryError)
          throw finalRetryError
        }
      }
    } else {
      // Otro tipo de error
      console.error(`Error al guardar en localStorage '${parameter}':`, error)
      throw error
    }
  }
}

export const getLStorage = (parameter: string): any | null => {
  try {
    const data = localStorage.getItem(parameter);
    return data ? JSON.parse(data) : null;
  } catch (error) {
    console.error("Error parsing data from localStorage:", error);
    return null;
  }
}

export const removeLStorage = (parameter: string) => {
  localStorage.removeItem(parameter)
  return null
}

export const get_set_ls = (varStorage: string, data: any) => {
  let dat1: any = getLStorage(varStorage)
  if (dat1 == null) {
    setLStorage(varStorage, [])
    dat1 = getLStorage(varStorage)
    dat1.push(data + "")
    setLStorage(varStorage, dat1)
  } else {
    //if (dat1.indexOf(data + "") == -1) {
      dat1.push(data + "")
      setLStorage(varStorage, dat1)
    //}
  }
}

export const setSStorage = (parameter: string, data: any) => {
  sessionStorage.setItem(parameter, JSON.stringify(data))
}

export const getSStorage = (parameter: string): any | null => {
  const data = sessionStorage.getItem(parameter);
  if (!data) return null;
  try {
    return JSON.parse(data);
  } catch (error) {
    console.error("Error parsing JSON from sessionStorage: ", error);
    return null;
  }
}

export const removeSStorage = (parameter: string) => {
  sessionStorage.removeItem(parameter)
  return null
}
export const copyObject = (obj, map = new WeakMap()) => {
  if (obj instanceof Date) {
    return new Date(obj);
  }
  if (obj instanceof RegExp) {
    return new RegExp(obj.source, obj.flags);
  }
  if (typeof obj === 'function') {
    return obj;
  }
  if (map.has(obj)) {
    return map.get(obj);
  }
  if (Array.isArray(obj)) {
    const arrCopy = [];
    map.set(obj, arrCopy);
    obj.forEach((val, index) => {
      arrCopy[index] = copyObject(val, map);
    });
    return arrCopy;
  }
  if (obj && typeof obj === 'object') {
    const objCopy = Object.create(Object.getPrototypeOf(obj));
    map.set(obj, objCopy);
    Reflect.ownKeys(obj).forEach(key => {
      objCopy[key] = copyObject(obj[key], map);
    });
    return objCopy;
  }
  return obj;
}

export const chunkify = (a: any[], n: number, balanced: boolean = false) => {
  if (n < 2) return [a]

  let len = a.length, out = [], i = 0, size = null

  if (len % n === 0) {
    size = Math.floor(len / n)
    while (i < len) out.push(a.slice(i, i += size))
  }

  else if (balanced) {
    while (i < len) {
      size = Math.ceil((len - i) / n--)
      out.push(a.slice(i, i += size))
    }
  }

  else {
    n--
    size = Math.floor(len / n)
    if (len % size === 0) size--
    while (i < size * n) out.push(a.slice(i, i += size))
    out.push(a.slice(size * n))
  }

  return out
}

const exportTableToExcel = (function () {
  var uri = 'data:application/vnd.ms-excel;base64,',
    template =
      '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body><table>{table}</table></body></html>',
    base64 = function (s) {
      return window.btoa(unescape(encodeURIComponent(s)))
    },
    format = function (s, c) {
      return s.replace(/{(\w+)}/g, function (m, p) {
        return c[p]
      })
    }
  return async function (table: string, name: string, totalTable: number) {
    let body = '';
    let tableVertical = '';
    if (totalTable > 0) {
      for (let i = 0; i < totalTable; i++) {
        let tableElement = document.getElementById('MinutaVertical' + i);
        if (tableElement) {
          let modifiedTable = removeColumns(tableElement);
          tableVertical += await new Promise(resolve => setTimeout(() => resolve(modifiedTable.innerHTML + '\n\n'), 333));
        }
      }
      body = fixTable(tableVertical)
      body = body
        .split('background-color')
        .join('')
    } else {
      let nameTable = table;
      if (table === "0") {
        nameTable = "MinutaHorizontal" + table;
      }
      let tableElement = document.getElementById(nameTable);
      if (tableElement) {
        if (name == "Planilla Contrato") {
          body = fixTable(tableElement.innerHTML);
        } else {
          let modifiedTable = removeColumns(tableElement);
          body = fixTable(modifiedTable.innerHTML);
        }

      }
    }
    const xlsTable = "<table border='1'>" + body + "</table>";
    let dataContratoGrilla = await getLStorage('dataContratoGrilla')
    dataContratoGrilla = JSON.parse(dataContratoGrilla)
    let contrato_ceco = (dataContratoGrilla.ser_nombre || dataContratoGrilla.servicio) + "_" + (dataContratoGrilla.id_contrato || dataContratoGrilla.id) + "_" + dataContratoGrilla.ceco
    downloadTableExcel(xlsTable, contrato_ceco);
  }
})()

function removeColumns(tableElement: HTMLTableElement): HTMLTableElement {
  const columnsToRemove = Array.from(tableElement.tHead.rows[0].cells)
    .map((cell, index) => ({
      index,
      shouldRemove: cell.textContent.includes("% ponderado") ||
        cell.textContent.includes("$ plato") ||
        cell.textContent.includes("$ Plato Pond.")
    }))
    .filter(column => column.shouldRemove)
    .map(column => column.index)
    .sort((a, b) => b - a);
  const removeColumnsFromRow = (row: HTMLTableRowElement): HTMLTableRowElement => {
    columnsToRemove.forEach(index => {
      if (index < row.cells.length) {
        row.deleteCell(index);
      }
    });
    return row;
  };
  const table = tableElement.cloneNode(true) as HTMLTableElement;
  Array.from(table.rows).forEach(removeColumnsFromRow);

  return table;
}



const downloadTableExcel = (table: string, name_file: string) => {
  var encabezado = `<html><head><meta http-equiv="content-type"
  content="text/plain; charset=UTF-8"/><style> table, td {border:thin solid 
  black} table {border-collapse:collapse}</style></head><body><table>`;
  var tabla = encabezado + table;
  var myBlob = new Blob([tabla], { type: 'text/html' });
  var url = window.URL.createObjectURL(myBlob);
  var a = document.createElement("a");
  document.body.appendChild(a);
  a.href = url;

  a.download = name_file != undefined ? name_file + ".xls" : "export.xls";
  a.click();
}

const fixTable = (table) => {
  return table
    .split('</a>')
    .join('</span>')
    .split('<a href="#"')
    .join('<span')
    .split('<button type="button"')
    .join('<span')
    .split('</button>')
    .join('</span>')
    .split('<img class="img-icon-table" src="../../media/icons/foods/carne.png">')
    .join('')
    .split('<img class="img-icon-table" src="../../media/icons/foods/pavo.png">')
    .join('')
    .split('<img class="img-icon-table" src="../../media/icons/foods/fideos.png">')
    .join('')
    .split('<img class="img-icon-table" src="../../media/icons/foods/arroz.png">')
    .join('')
    .split('<img class="img-icon-table" src="../../media/icons/foods/verduras.png">')
    .join('')
    .split('<img class="img-icon-table" src="../../media/icons/foods/patata.png">')
    .join('')
    .split('<img class="img-icon-table" src="../../media/icons/foods/gelatina.png">')
    .join('')
    .split('<img')
    .join('<span')
    .split('<input type=\"number\" class=\"form-control\"')
    .join('<span')
    .split('value=\"')
    .join('>')
    .split('" style=\"height: 0px; width: 115px;\"')
    .join('</span')
    .split('style="height: 90px;"')
    .join('')
}

export const getUserByToken = () => {
  const token = localStorage.getItem('accessToken')
  if (token) {
    const arr: any = token.split('.')[1]
    const dataUser: any = atob(arr)
    const obj: any = JSON.parse(dataUser)
    const keys: any = Object.keys(obj)

    return {
      user: obj[keys[0]],
      emailaddress: obj[keys[1]],
      role: obj[keys[2]],
      idUser: obj[keys[3]],
    }
  }
}

const jsonToExcel = (arrayMinutaCliente: any, cabecera: any, header?: any) => {
  var uri = 'data:application/vnd.ms-excel;base64,',
    template =
      '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body><table>{table}</table></body></html>',
    base64 = function (s) {
      return window.btoa(unescape(encodeURIComponent(s)))
    },
    format = function (s, c) {
      return s.replace(/{(\w+)}/g, function (m, p) {
        return c[p]
      })
    }
  if (header) {
    const resultHeader = header?.map((item) => {
      return arrayMinutaCliente[0][item];
    })
    const name = "Minuta Cliente 2"
    let htmlTables = `
    <table border="1">
      <tr>
        <th>Ceco</th>
        <th>Contrato</th>
        <th>Regimen</th>
        <th>Servicio</th>
      </tr>
      <tr>
      <td>${cabecera[0].ceco}</td>
      <td>${cabecera[0].contrato}</td>
      <td>${cabecera[0].regimen}</td>
      <td>${cabecera[0].servicio}</td>
      </tr>
    </table>
    <br />
    <table border="1">
    <tr>
  `;
    resultHeader?.map((item) => {
      if (item !== undefined)
        htmlTables += `<th>${item}</th>`;
    });
    htmlTables += `</tr>`;
    arrayMinutaCliente.forEach((item2, key2) => {
      if (key2 > 0) {
        htmlTables += `<tr>`;
        header?.map((item, key) => {
          if (item2[item] !== undefined)
            htmlTables += `<td>${item2[item]}</td>`;
        })
        htmlTables += `</tr>`;
      }
    })
    htmlTables += `</tr></table>`;
    downloadTableExcel(htmlTables);
  } else {
    const name = "Minuta Cliente 1"
    let htmlTables = `
    <table border="1">
      <tr>
        <th>Ceco</th>
        <th>Contrato</th>
        <th>Regimen</th>
        <th>Servicio</th>
      </tr>
      <tr>
      <td>${cabecera[0].ceco}</td>
      <td>${cabecera[0].contrato}</td>
      <td>${cabecera[0].regimen}</td>
      <td>${cabecera[0].servicio}</td>
      </tr>
    </table>
    <br />
    <table border="1">
    <tr>
      <th>Grupo Estructura</th>
      <th>Estructura</th>
  `;
    const headMinuta = Object.keys(arrayMinutaCliente[0]).filter(item => item.includes("-"))
    headMinuta?.map((item) => {
      if (item !== undefined) {
        htmlTables += `<th>${item}</th>`;
      }
    });
    htmlTables += `</tr>`;

    //

    arrayMinutaCliente?.map((row) => {
      htmlTables += `<tr>
      <td>${row.GrupoEstructura}</td>
      <td>${row.Estructura}</td>`;

      headMinuta?.map((item) => {
        if (item !== undefined)
          htmlTables += `<td>${row[item]}</td>`;
      });
      htmlTables += `</tr>`;
    }
    );
    downloadTableExcel(htmlTables);
  }
}

const excelFileToJSON = (file: any, setFile: any) => {
  try {
    var reader = new FileReader();
    reader.readAsBinaryString(file);
    return reader.onload = function (e) {
      var data = e.target.result;
      var workbook = XLSX.read(data, {
        type: 'binary'
      });
      var result = {};
      workbook.SheetNames.forEach(function (sheetName) {
        var roa = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheetName]);
        if (roa.length > 0) {
          result[sheetName] = roa;
        }
      });
      setFile(result);
    }
  } catch (e) {
    console.error(e);
  }
}

export { fetchData, fotmatDateHeader, fotmatDateHeader2, exportTableToExcel, jsonToExcel, excelFileToJSON }
